export default __webpack_public_path__ + "static/media/SEC0222.34I-38367_-25113_0.c41d3157.jpg";